import { LabClient } from 'models/client-directory';
import { Order } from 'models/order';

export const isPtjInternalOrganization = (organizationNumber: string): boolean => {
    return organizationNumber === '556077-2419';
};

export const hasPtjCustomerNumber = (order: Order, parentClientSetting: LabClient): boolean => {
    if (isPtjInternalOrganization(order.customer?.organizationNumber)) {
        if (isPtjInternalOrganization(order.supplier.organizationNumber)) {
            return !!order.customer?.ptjCustomerNumber;
        }
        return true;
    }
    return !!parentClientSetting?.ptjCustomerNumber;
};
